import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setResourceEmpty } from "../../../ducks/catalog/catalog";

export const useResourceEmpty = (noResources: boolean) => {
  const dispatch = useDispatch();
  const setIsResourceEmpty = useCallback((empty: boolean) => dispatch(setResourceEmpty(empty)), [dispatch]);

  useEffect(() => {
    setIsResourceEmpty(noResources);
  }, [noResources]);
};
